export default __webpack_public_path__ + "static/media/starFadeOut.c8f049e5.mp3";